import React from "react";

/**
 * CSS-only Android phone bezel. Pass children to render the screen content.
 * Sizes can be tweaked via className override on root.
 */

const PhoneMockup = ({
  children,
  className = "",
  screenClassName = "",
}) => {
  return (
    <div
      data-testid="phone-mockup"
      className={`relative mx-auto h-[480px] w-[240px] rounded-[2.6rem] bg-ink p-3 shadow-[0_30px_80px_-20px_rgba(10,10,10,0.45)] md:h-[560px] md:w-[280px] ${className}`}
    >
      <div className="absolute -right-[3px] top-28 h-16 w-[3px] rounded-r bg-ink/80" />

      <div className="absolute -left-[3px] top-24 h-10 w-[3px] rounded-l bg-ink/80" />

      <div className="absolute -left-[3px] top-40 h-16 w-[3px] rounded-l bg-ink/80" />

      <div
        className={`relative h-full w-full overflow-hidden rounded-[2rem] bg-cream ${screenClassName}`}
      >
        <div className="absolute left-1/2 top-2 z-20 h-2.5 w-2.5 -translate-x-1/2 rounded-full bg-ink/90" />

        {children}
      </div>
    </div>
  );
};

export default PhoneMockup;